// Site-wide config constants for SEO + Schema.org modules.
// TODO:TECH: lock SITE.url после выбора домена (см. CLAUDE.md open decisions).
export const SITE = {
  url: process.env.NEXT_PUBLIC_SITE_URL || 'https://cortexit.ru',
  brand: 'Cortex IT',
  brandTagline: 'Автоматизируем бизнес-процессы. Один процесс end-to-end за 1-2 месяца.',
  founder: {
    name: 'Дмитрий Пименов',
    title: 'Principal Consultant',
    role: 'Founder & Principal Consultant',
  },
  description:
    'Cortex IT — автоматизируем бизнес-процессы на стеке Python / RAG / CV / Bitrix24. Один процесс end-to-end за 1-2 месяца от 150K RUB.',
  ogLocale: 'ru_RU',
  defaultLocale: 'ru',
} as const;
